import getLocal from '@/app/utils/getLocal';
import { shopifyProductVariantSelectById } from 'lowcode/apis/getShopifyProductList';
import GloLayout from 'lowcode/common/GloLayout';
import { BaseCardBtnText } from 'lowcode/common/LangText/BaseCardBtnText';
import MemberCardItem from 'lowcode/common/MemberCommon/member-card/MemberCardItem';
import IconMore from 'lowcode/common/MemberCommon/member-card/MemberCardItem/comps/IconMore';
import { Fragment, useEffect, useRef, useState } from 'react';
import './index.scss';
import SelectItems from './SelectItems';
//import SelectItems from './SelectItems';

const _ALL_KEY = '_ALL_';
// 获取变体ID
const getVariantIdOut = (list: any, allText: string) => {
    const resultId = [];
    const searchArray: any[] = [
        {
            value: _ALL_KEY,
            label: allText || 'All',
        },
    ]; //主机及品类
    for (let i = 0; i < list.length; i++) {
        const itemA = list[i];
        const itemsA1 = itemA.items || [];
        for (let j = 0; j < itemsA1.length; j++) {
            const itemB = itemsA1[j];
            if (itemB.variantId) {
                resultId.push(itemB.variantId);
            }
            if (itemB.priceVariantId) {
                resultId.push(itemB.priceVariantId);
            }
            if (itemB.compareAtPriceVariantId) {
                resultId.push(itemB.compareAtPriceVariantId);
            }
            if (itemB.memberVariantId) {
                resultId.push(itemB.memberVariantId);
            }
            // 主机及品类
            const hostAndCategory = itemB.hostAndCategory || [];
            if (hostAndCategory.length) {
                for (let k = 0; k < hostAndCategory.length; k++) {
                    const hostItem = hostAndCategory[k];
                    if (!hostItem) {
                        continue;
                    }
                    const value = hostItem.value;
                    const label = hostItem.label;
                    if (!value || !label) {
                        continue;
                    }

                    const isInFlag = searchArray.find((item: any) => {
                        return item.value === value;
                    });

                    if (isInFlag) {
                        continue; //已添加
                    }
                    searchArray.push({
                        value: value,
                        label: label,
                    });
                }
            }
        }
    }
    const resultId2 = Array.from(new Set(resultId));
    return {
        resultId: resultId2,
        searchArray,
    };
};

// 从 list 中,取为所有的item组成 ALL
const getAllFromItems = (listA: any[], allText: string) => {
    const list2: any[] = JSON.parse(JSON.stringify(listA));
    const allTabKey = _ALL_KEY;
    const itemAllDefault = {
        tabValue: allTabKey,
        tabLabel: allText,
        items: [],
    };
    const itemAll = itemAllDefault;
    let isHadInList = false; //listA中是否已有 ALL
    // 取出 listAll
    for (let i = 0; i < listA.length; i++) {
        const itemA: any = listA[i];
        if (itemA.tabValue === allTabKey) {
            isHadInList = true;
        }
    }
    // 遍历取出item到list中
    const allItems: any = itemAll.items || [];
    for (let i = 0; i < listA.length; i++) {
        const itemA: any = listA[i];
        const listB = itemA.items || [];
        if (itemA.tabValue === allTabKey) {
            continue;
        }
        for (let j = 0; j < listB.length; j++) {
            const itemB = listB[j];
            allItems.push(itemB);
        }
    }
    if (isHadInList) {
        list2.splice(0, 1, itemAll);
    } else {
        list2.unshift(itemAll);
    }

    return list2;
};

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const initIndex2 = isEditStatus ? initIndex + 1 : initIndex;
    const { locale = 'us' } = getLocal();
    const TextA = BaseCardBtnText[locale] || BaseCardBtnText['us'];
    const { list = [], cardBgColor, title, titleColor, subTitle, subTitleColor } = data;
    const resultData = getVariantIdOut(list, TextA.All);
    const list2Copy = getAllFromItems(list, TextA.All);
    const refList = useRef(list2Copy);
    const searchOptions = resultData.searchArray || [];
    const styleComp: any = {
        '--member-h-titleColor': titleColor,
        '--member-h-subTitleColor': subTitleColor,
    };
    const [activeIndex, setActiveIndex] = useState(initIndex2);
    const [items, setItems] = useState(list2Copy[activeIndex]?.items || []);
    const itemsRef = useRef(list2Copy[activeIndex]?.items || []);
    const cardType = 'three';
    const [showMore, setShowMore] = useState(false); // 更多
    const searchValueRef = useRef(_ALL_KEY); //查询内容

    // 更多
    const moreHandle = () => {
        const showMore2 = !showMore;
        setShowMore(showMore2);
    };
    // tab切换
    const tabChange = (item: any, index: number) => {
        setActiveIndex(index);
        const items2 = refList.current[index]?.items || [];
        //setItems(items2 || []);
        itemsRef.current = items2 || [];
        setShowMore(false);
        searchCallback2(searchValueRef.current, items2);
    };
    // 执行选择
    const searchCallback = (searchValue: string) => {
        searchValueRef.current = searchValue;
        searchCallback2(searchValue, itemsRef.current);
    };
    // 执行查询
    const searchCallback2 = (searchValue: string, itemsB: any[]) => {
        if (searchValue === _ALL_KEY) {
            setItems(itemsB);
            return false;
        }

        const items2 = [];
        for (let i = 0; i < itemsB.length; i++) {
            const itemA = itemsB[i];
            const hostAndCategory = itemA.hostAndCategory || [];
            const isFind = hostAndCategory.find((item: any) => {
                return item.value === searchValue;
            });
            if (isFind) {
                items2.push(JSON.parse(JSON.stringify(itemA)));
            }
        }

        setItems(items2);
    };
    useEffect(() => {
        const initDataHandle = async () => {
            const productList1 = await shopifyProductVariantSelectById(locale, resultData.resultId);
            // 从 array 变成针对 variantId 的 object
            const productObject: any = {};
            productList1.forEach((item: any) => {
                productObject[item.variantId] = item;
            });
            const listA1 = JSON.parse(JSON.stringify(refList.current));
            for (let i = 0; i < listA1.length; i++) {
                const item1 = listA1[i];
                const items2 = item1.items || [];
                items2.forEach((item: any) => {
                    // 主产品信息
                    const variantId = item.variantId;
                    const itemA1 = productObject[variantId];
                    if (variantId && itemA1) {
                        item.productId = itemA1.productId; // 必须将产品id同步过来，因为加购物车时需要请求判断是否有优惠券或者礼品卡，该接口后端必须传参产品id
                        item.shopifyTitle = itemA1.title;
                        item.inventory = itemA1.inventoryQuantity;
                        item.shopifyPc = itemA1.img || item.shopifyPc;
                    }
                    // 售价
                    const priceVariantId = item.priceVariantId;
                    const itemA2 = productObject[priceVariantId];
                    if (priceVariantId && itemA2) {
                        item.shopifyPricePrice = itemA2.price;
                        item.shopifyPriceCompareAtPrice = itemA2.compareAtPrice;
                    }
                    // 划线价
                    const compareAtPriceVariantId = item.compareAtPriceVariantId;
                    const itemA3 = productObject[compareAtPriceVariantId];
                    if (compareAtPriceVariantId && itemA3) {
                        item.shopifyCompareAtPricePrice = itemA3.price;
                        item.shopifyCompareAtPriceCompareAtPrice = itemA3.compareAtPrice;
                    }
                    // 会员价
                    const memberVariantId = item.memberVariantId;
                    const itemA4 = productObject[memberVariantId];
                    if (memberVariantId && itemA4) {
                        item.shopifyMemberPrice = itemA4.price;
                        item.shopifyMemberCompareAtPrice = itemA4.compareAtPrice;
                    }
                });
            }
            const listA2 = getAllFromItems(listA1, TextA.All);
            refList.current = listA2;
            setItems(listA2[activeIndex]?.items || []);
        };
        if (!isEditStatus) {
            initDataHandle();
        }
    }, []);

    useEffect(() => {
        if (isEditStatus) {
            setItems(list2Copy[activeIndex]?.items || []);
            itemsRef.current = list2Copy[activeIndex]?.items || [];
        }
    }, [data]);
    const isShowSearch = searchOptions.length > 1;
    return (
        <GloLayout id={id} className={`temp-member-product-scene temp-member-product-accessory temp-member-product-accessory-${cardType} temp-hide`}>
            <div className={`temp-member-product-scene-h ef-content ${title || subTitle ? '' : ' temp-member-product-scene-h-hide'}`} style={styleComp}>
                <div className="temp-member-product-scene-h-title">{title}</div>
                <div className="temp-member-product-scene-h-subTitle">{subTitle}</div>
            </div>
            {isShowSearch && <SelectItems searchOptions={searchOptions} callback={searchCallback} />}
            {list2Copy.length > 1 && (
                <div className="temp-member-product-accessory-tab">
                    <div className="temp-member-product-accessory-tab-in1">
                        {list2Copy.map((item: any, index: number) => {
                            return (
                                <div
                                    key={index}
                                    className={`temp-member-product-accessory-tab-item${
                                        activeIndex === index ? ' temp-member-product-accessory-tab-item-active' : ''
                                    }`}
                                    onClick={() => {
                                        tabChange(item, index);
                                    }}
                                >
                                    {item.tabLabel}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            <div className={`temp-member-product-scene-in${showMore ? ' temp-member-product-scene-in-show-more' : ''}`}>
                {items.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <MemberCardItem item={item} cardType={cardType} cardBgColor={cardBgColor} isEditStatus={isEditStatus} />
                        </Fragment>
                    );
                })}
            </div>
            {items.length > 6 && (
                <div className={`temp-member-product-scene-btn-box`}>
                    <div className="temp-member-product-scene-btn" onClick={moreHandle}>
                        {showMore ? TextA.ViewLess : TextA.ViewMore}
                        <IconMore />
                    </div>
                </div>
            )}
        </GloLayout>
    );
}
